import * as React from "react";
import * as ReactDOM from "react-dom";
import ProfileEdit from "./ProfileEdit";
import ProfileView from "./ProfileView";

interface IProfileCompProps {
    isOwnProfile:boolean
    userId:number
}

interface IProfileCompState {
    editMode:boolean
}

export class ProfileComp extends React.Component<IProfileCompProps, IProfileCompState>{

    constructor(props:IProfileCompProps){
        super(props);
        this.init();
    }
    private init():void{
        var editMode:boolean = false;
        if ( window.location.href.indexOf('editMode') > -1 ) {
            editMode = true;
        }
        this.state={
            editMode: editMode
        };
    }

    private changeEditModeclickHandler(evt): void {
        evt.preventDefault();
        this.setState({
             editMode: !this.state.editMode
        });

    }


    render() {
/*         if ( this.state.editMode === true ) {
            document.querySelector('.editor_item_comp_image_row').classList.remove('hide');
        }else{
            document.querySelector('.editor_item_comp_image_row').classList.add('hide');
        } */
        return (
            <div>
                { this.props.isOwnProfile === true ? <div>
                    { this.state.editMode === true ? <div>
                        <button onClick={ (e) => { this.changeEditModeclickHandler(e); } } className="btn">
                        Előnézet
                    </button>
                    <br/>
                    <br/>
                    <ProfileEdit userId={ this.props.userId } />
                </div>:<div>
                    <button onClick={ (e) => { this.changeEditModeclickHandler(e); } } className="btn">
                        Szerkesztés
                    </button>
                    <br/>
                    <br/>
                    <ProfileView id={ this.props.userId } registrationMode={false} profileMode={true}/>
                </div> }
                </div>:
                <ProfileView id={ this.props.userId } registrationMode={false} profileMode={true}/> }

            </div>
        );
    }
}
export class InitProfileComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('profile_comp') as HTMLDivElement;
        if (div !== null) {
            var data:any = div.dataset;
            ReactDOM.render(<ProfileComp isOwnProfile={ data.is_own_profile==='true'?true:false } userId={ data.user_id } />, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/proifle/ProfileComp.tsx